import { useEffect, useState } from 'react';

export const transformNumberFormat = (num: any) => {

  const [transformedNumber, setTransformedNumber] = useState(null);

  useEffect(() => {
    let decimals = num.toString().split('.');
    let numerals = decimals.shift().split('');
    let aux = [];

    while (numerals.length > 0) {
      aux.unshift(numerals.splice(-3, 3).join(''));
    }
    if (decimals.length <= 0) {
      setTransformedNumber(aux.join('.') + ',00');
    } else if(decimals[0].length === 1 ) {
      setTransformedNumber(aux.join('.')+ ',' + decimals.toString() + '0');
    } else {
      setTransformedNumber(aux.join('.') + ',' + decimals.toString());
    }
  }, []);

  

  return transformedNumber ;
};
